import { render, staticRenderFns } from "./OrderPersonInfo.vue?vue&type=template&id=44b51b56&scoped=true"
import script from "./OrderPersonInfo.vue?vue&type=script&lang=js"
export * from "./OrderPersonInfo.vue?vue&type=script&lang=js"
import style0 from "./OrderPersonInfo.vue?vue&type=style&index=0&id=44b51b56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b51b56",
  null
  
)

export default component.exports